import { path } from "./path";

import type { IExtendedRouteObject } from "@routes/types.ts";
import { useUIStore } from "@/stores/uiStore";

export const messagesRoutes: IExtendedRouteObject[] = [
  {
    route: {
      path: path.messages.route,
      lazy: () => import("@pages/panelPages/messages/messages"),
      loader: ({ request }) => {
        useUIStore
          .getState()
          .setPage(request, "pageTitle.messages", [], "index");
        return {};
      },
    },
    permissions: [
      "patient",
      "admin",
      "super-admin",
      "doctor",
      "local-admin",
      "staff",
      "medical-service-provider-drug",
      "medical-service-provider-lab",
      "medical-service-provider-image",
    ],
  },
];
